module.exports = __webpack_public_path__ + "img/green-accent-1.b7363f66.svg";